/** @jsxRuntime classic */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

// TODO: react-scripts@4.0.3がマージされたが、
// pragmaがないとIEでは表示できなかったため、残している
// 今後引き続き検証する

import { Global } from '@emotion/react';
import { App } from 'App';
import { ROOT_ELEMENT_ID } from 'models';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from 'store';
import { ErrorBoundary } from './ErrorBoundary';

import * as serviceWorker from './serviceWorker';

import { globalStyle } from './styles';

const root = document.getElementById(ROOT_ELEMENT_ID);
const endpoint = root?.dataset.apiUrl;

ReactDOM.render(
  <React.StrictMode>
    <Global styles={globalStyle} />
    <Provider store={store}>
      <ErrorBoundary>
        <App endpoint={endpoint} />
      </ErrorBoundary>
    </Provider>
  </React.StrictMode>,
  root,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
